export enum CURRENT_STATE_T {
  NotAuthenticated = 'NotAuthenticated',
  Idle = 'Idle',
  Securing = 'Securing',
  Secured = 'Secured',
  Submitting = 'Submitting',
  Success = 'Success',
  Failure = 'Failure'
}
